<template>
  <div id="products">
    <div>
      <div class="social-nav filter-blur-50 border-bottom-white-1-50">
        <div class="tabsContainer tabAlign w-100">
          <v-tabs v-model="tab" grow centered show-arrows class="social-tab">
            <v-tabs-slider color="#FFCB05"></v-tabs-slider>
            <v-tab v-for="(item, i) in info.items" :key="item.title">
              <span
                :class="[(lang === 'ar' && i !== tab ? 'regular-ar' : i !== tab ? 'regular-en' : lang === 'ar' && i === tab ? 'bold-italic-ar' : 'bold-italic-en')]">{{
                  item.title }}</span>
            </v-tab>
          </v-tabs>
        </div>
      </div>
      <v-tabs-items v-model="tab" :touchless="true">
        <div class="products-container">
          <v-tab-item v-for="item in info.items" :key="item.title">
            <component :is="item.comp" />
          </v-tab-item>
        </div>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import MtnLines from './MtnLines'
import SegmentProducts from './SegmentProducts'
import PaymentAndRefill from './PaymentAndRefill'
import CallManagement from './CallManagement'
import InternationalCallsChanges from './InternationalCallsChanges'
import utils from '../../shared/utils'
import $ from 'jquery'
import Navbar from '../Navbar'
export default {
  name: 'Products',
  components: { Navbar, MtnLines, SegmentProducts, PaymentAndRefill, CallManagement, InternationalCallsChanges },
  data () {
    return {
      tab: null,
      info: { title: this.$t('products.title'), items: [{ title: this.$t('products.toolbar.lines.title'), comp: 'MtnLines', path: 'mtn-lines' }, { title: this.$t('products.toolbar.segment'), comp: 'SegmentProducts', path: 'segment-products' }, { title: this.$t('products.toolbar.payment'), comp: 'PaymentAndRefill', path: 'payment' }, { title: this.$t('products.toolbar.call'), comp: 'CallManagement', path: 'call-management' }, { title: this.$t('products.toolbar.international'), comp: 'InternationalCallsChanges', path: 'international-calls' }] },
      activeTab: '',
      lang: this.$lang,
      width: this.$store.state.window
    }
  },
  created () {
    this.activeTab = this.$route.params.id
    this.$store.state.activeSectionNav = null
  },
  mounted () {
    this.arabic()
    this.tab = utils.checkActiveTab(this.info.items, this.activeTab)
    this.$watch(() => {
      return this.$store.state.window
    }, val => {
      this.width = val
    })
  },
  methods: {
    arabic () {
      if (this.$lang === 'ar') {
        $('.social-nav').css('direction', 'rtl')
        $('.arrowIcon').css('transform', 'rotateY(180deg)')
        $('.tabsContainer').addClass('arabicTabContainer')
        $('.social-tab .v-tab').css('transform', 'rotateY(180deg)')
        $('.social-tab .v-tab').css('padding', '0 3vw')
        // $('.tabAlign').css('padding', '0px 6vw 0 8vw')
      }
    }
  },
  watch: {
    tab (val) {
      window.scrollTo(0, 0)
      this.$store.state.tab = val
      $('#press_releases .tabsContainer').addClass('arabicTabContainer')
      $('#press_releases .innerTabContainer .v-tab').css('transform', 'rotateY(180deg)')
    },
    '$route.params.id': {
      handler: function (id) {
        this.tab = utils.checkActiveTab(this.info.items, id)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style lang="scss" >
@import "src/assets/sass/main";

#products {
  .theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active) {
    color: rgba(29, 29, 29, 0.6) !important;
  }

  .tabsContainer {
    height: 50px;
  }

  .social-tab .v-tab--active {
    color: $--yellow !important;
  }

  .social-tab .v-tab--active {
    color: $--yellow !important;
    font-family: Mtn-bold;
    font-size: 12px;
  }

  .social-nav {
    width: 100%;
    height: 50px;
    background: rgba(249, 249, 249, 1);
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
    margin: 0px 0px;
    display: flex;
    position: fixed;
    z-index: 10;
    z-index: 210;
    top: 110px;
  }

  .social-nav .v-tabs,
  .v-tabs-bar {
    height: 100%;
  }

  .theme--light.v-tabs>.v-tabs-bar {
    background: transparent !important;
  }

  .social-nav .v-tabs {
    display: flex;
    justify-content: space-around !important;
    align-items: center !important;
  }

  .social-tab .v-tab {
    padding: 0 2vw;
    font-size: 13px;
    text-transform: capitalize;
  }

  .tabAlign {
    padding: 0 4vw;
  }

  @media only screen and (max-width: 650px) {
    //.tabsContainer{
    //  width: 100vw !important;
    //}
  }

  .arabicTabContainer {
    direction: ltr;
    transform: rotateY(180deg);
  }
}
</style>
<style scoped>
.products-container {
  min-height: calc(100vh - (160px + 285.6px)) !important;
  padding-top: 155px;
}

#products .social-tab .v-tab {
  direction: ltr !important;
}

.content-header .v-tabs-bar.v-item-group>* {
  width: 100vw !important;
}
</style>
<style>
#products .content-header .theme--light.v-tabs>.v-tabs-bar {
  width: 100% !important;
}
</style>
